import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { fieldOptionProjectsLimitsResource } from '@jira/router-resources__admin-pages-performance/src/fieldOptionProjectsLimitsResource.tsx';
import { notFoundEntrypoint } from '@jira/spa-apps__error-pages-not-found/src/notFoundEntrypoint.entrypoint.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsPerformanceCustomFieldOptionProjectLimitRoute } from '@jira/router-routes__admin-pages-performance-routes/src/globalSettingsPerformanceCustomFieldOptionProjectLimitRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { customFieldOptionProjectLimitMetricDetailEntryPoint } from './ui/spa/admin-pages/performance/metric-detail/custom-field-option/project-limit/CustomFieldOptionProjectLimitEntryPoint.tsx';

const notFoundPageEntrypoint = createPageEntryPoint({
	main: notFoundEntrypoint,
});

const getCustomFieldOptionProjectLimitResources = () =>
	fg('slt1-1341_site_optimizer_add_cfo_isl_metrics')
		? [
				...getNavigationResources(),
				navigationSidebarGlobalResource,
				fieldOptionProjectsLimitsResource,
			]
		: [...getNavigationResources(), navigationSidebarGlobalResource];

export const globalSettingsPerformanceCustomFieldOptionProjectLimitRouteEntry: Route = createEntry(
	globalSettingsPerformanceCustomFieldOptionProjectLimitRoute,
	() => ({
		group: 'global-settings',

		canTransitionIn: () => fg('slt1-1341_site_optimizer_add_cfo_isl_metrics'),

		entryPoint() {
			if (!fg('slt1-1341_site_optimizer_add_cfo_isl_metrics')) {
				return notFoundPageEntrypoint;
			}
			return customFieldOptionProjectLimitMetricDetailEntryPoint;
		},

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
			menuId: MenuIdSettings,
		},

		resources: getCustomFieldOptionProjectLimitResources(),

		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
